import React, { useState, useEffect } from 'react';
import { Box, TextField, List, ListItem, ListItemButton, ListItemText, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

function CustomerLookup({ initialQuery = '' }) {
  const [query, setQuery] = useState(initialQuery);
  const [result, setResult] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query) {
      setResult([]);
      return;
    }
    const fetchCustomers = async () => {
      try {
        let encodedParam = encodeURIComponent(query);
        let url = process.env.REACT_APP_API_URL + 'customers/?search=' + encodedParam;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        setResult(response.data);
      } catch (error) {
        setResult([]);
        console.error(error);
      }
    };
    fetchCustomers();
  }, [query]);

  return (
    <Paper sx={{ p: 2, my: 1, width: 'min(100%, 400px)', mx: 'auto' }}>
      <Box sx={{ position: 'relative' }}>
        <TextField
          label="Quick Customer Lookup"
          value={query}
          onChange={e => setQuery(e.target.value)}
          fullWidth
          size="small"
          autoComplete="off"
        />
        {query && (
          <List
            sx={{
              position: 'absolute',
              top: '100%',
              left: 0,
              width: '100%',
              bgcolor: 'background.paper',
              boxShadow: 3,
              zIndex: 10,
              maxHeight: 240,
              overflowY: 'auto'
            }}
          >
            <ListItemButton onClick={() => navigate('/customers/add')}>
              <AddIcon fontSize="small" sx={{ mr: 1 }} />
              <ListItemText primary="Add new customer" />
            </ListItemButton>
            {result.length === 0 ? (
              <ListItem>
                <ListItemText primary="No matches found" />
              </ListItem>
            ) : (
              result.map(c => (
                <ListItemButton key={c.id} onClick={() => navigate(`/customers/${c.id}`)}>
                  <ListItemText primary={c.first_name + ' ' + c.last_name} secondary={c.phone} />
                </ListItemButton>
              ))
            )}
          </List>
        )}
      </Box>
    </Paper>
  );
}

export default CustomerLookup;